import { Typography } from "@mui/material";

const MusicSfxPanel = () => <Typography sx={{ color: "text.secondary" }}>TODO: Music &amp; SFX settings.</Typography>;

export default MusicSfxPanel;
